import { render, staticRenderFns } from "./activity_secondkill_edit.vue?vue&type=template&id=eddbac10&scoped=true"
import script from "./activity_secondkill_edit.vue?vue&type=script&lang=js"
export * from "./activity_secondkill_edit.vue?vue&type=script&lang=js"
import style0 from "./activity_secondkill_edit.vue?vue&type=style&index=0&id=eddbac10&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddbac10",
  null
  
)

export default component.exports